import { render } from "./MathAnswerForm.vue?vue&type=template&id=1de17eaa&ts=true"
import script from "./MathAnswerForm.vue?vue&type=script&lang=ts"
export * from "./MathAnswerForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__